var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('footer',{staticClass:"footer"},[_c('p',{staticClass:"copy"},[_vm._v("© "+_vm._s(_vm.year)+" StackOvergrow. All rights reserved.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }